module.exports = {"id":"215391","name":"Ibrahima Seck","rating":"73","photo":"./data/images/photos/1/215391.png","club":{"name":"KRC Genk","logo":"./data/images/clubs/KRCGenk.png"},"positions":["MDC","MC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/IbrahimaSeck0.json
// module id = 1772
// module chunks = 0